import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { BENEFIT_LIST } from './consts/benefitList';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'SearchByBenefit';
const PARAM_NAME = 'preferredSearchCriteria';

export type SearchByReviewPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const SearchByBenefit = (props: SearchByReviewPropsType) => {
  const { userAnswers, commonAnswerHandler, onApplyHandler: onApplyHandlerFromProps } = props;
  const onApplyHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;
    commonAnswerHandler(PARAM_NAME, value || '');

    userAnswers.push({
      keyName: 'searchByBenefit',
      paramName: PARAM_NAME,
      question: '重視したい業者の絞り込み条件は',
      answer: value || '',
      value: value || '',
    });

    onApplyHandlerFromProps();
  }, [commonAnswerHandler, onApplyHandlerFromProps, userAnswers]);

  return (
    <div
      css={css`
        width: 100%;

        ${tablet(() => css`
          max-width: 568px;
          margin-inline: auto;
          padding: 0 1em;
        `)}
      `}
    >
      <div
        css={css`
          margin-bottom: 24px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            margin-bottom: ${setAutomaticDesignBasedSize(24, 20)};
          `)}
        `}
      >
        <p
          css={css`
            color: #000;
            font-size: 20px;
            font-weight: bold;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              font-size: ${setAutomaticDesignBasedSize(20, 18)};
            `)}
          `}
        >
          利用できるサービスから探す
        </p>
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0 5px;
        `}
      >
        {BENEFIT_LIST.map((companyInfomation) => {
          const { id, iconElement, text } = companyInfomation;

          return (
            <button
              key={id}
              value={text}
              onClick={onApplyHandler}
              id={`ga_event_${KEY_NAME}_button_${id}`}
              css={css`
                color: #041156;
                font-size: 12px;
                font-weight: bold;
                text-align: center;
                padding: 15px 1em;
                background-color: #fff;
                border: 1px solid #041156;
                border-radius: 8px;

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(12, 11)};
                  padding: ${setAutomaticDesignBasedSize(15, 12)} 0;
                `)}

                &:hover {
                  background-color: #fff7c9;
                }
              `}
            >
              <span
                css={css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: fit-content;
                  height: 32px;
                  margin-inline: auto;
                  margin-bottom: 7px;

                  ${mobile(({ setAutomaticDesignBasedSize }) => css`
                    height: ${setAutomaticDesignBasedSize(32, 29)};
                  `)}
                `}
              >
                <span
                  css={css`
                    font-size: 0;
                    width: 33px;
                    max-height: 100%;

                    ${mobile(({ setAutomaticDesignBasedSize }) => css`
                      width: ${setAutomaticDesignBasedSize(33, 29)};
                    `)}

                    ${id === 2 && css`
                      width: 23px;

                      ${mobile(({ setAutomaticDesignBasedSize }) => css`
                        width: ${setAutomaticDesignBasedSize(23, 20)};
                      `)}
                    `}

                    ${id === 3 && css`
                      width: 60px;

                      ${mobile(({ setAutomaticDesignBasedSize }) => css`
                        width: ${setAutomaticDesignBasedSize(60, 53)};
                      `)}
                    `}
                  `}
                >
                  {iconElement}
                </span>
              </span>
              <span
                css={css`
                  display: block;
                `}
              >
                {text}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
